module.exports = __webpack_public_path__ + "img/icono.355274d4.png";